import { Modal, Box, TextField, MenuItem, Button, Typography, CardContent, Card, Grid, Paper } from '@mui/material'
import { useState, useEffect } from 'react'
import moment from 'moment'
import 'moment/locale/th'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50vw',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    '& .MuiTextField-root': { m: 1 }
};

export default function ReceiptView(props) {
    const { receiptViewModalOpen, setReceiptViewModalOpen, receiptViewData } = props
    return (
        <Modal
            open={receiptViewModalOpen}
            onClose={() => {
                setReceiptViewModalOpen(false)
                // setDefaultWasteFeeData()
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={style}
                component='form'
                onSubmit={(event) => {
                    setReceiptViewModalOpen(false)
                }}
            >
                <Paper sx={{ p: 1 }}>
                    <Typography variant='h5' >แสดงข้อมูลใบเสร็จ</Typography >
                    <Typography sx={{ m: 1 }}>เลขที่ใบเสร็จ : {receiptViewData.receipt_no}</Typography>
                    <Typography sx={{ m: 1 }}>ยอดชำระรวม : {receiptViewData.total_fee} บาท</Typography>
                    <Typography sx={{ m: 1 }}>วันที่ออกใบเสร็จ : {moment(receiptViewData.receipt_date).add(543, 'year').format('DD MMMM YYYY')}</Typography>
                    <Typography sx={{ m: 1 }}>บันทึกใบเสร็จโดย : {receiptViewData.fname + ' ' + receiptViewData.lname}</Typography>
                </Paper>
            </Box>
        </Modal>
    )
}
